import { render } from "./KeywordGenerationStep.vue?vue&type=template&id=630d3479"
import script from "./KeywordGenerationStep.vue?vue&type=script&lang=js"
export * from "./KeywordGenerationStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__